import React from 'react';
import SimpleLayout from '@/layouts/SimpleLayout';
import RegisterHeroSection from './components/RegisterHeroSection';
import RegisterFormSection from './components/RegisterFormSection';
import RegisterFeaturesSection from './components/RegisterFeaturesSection';
import RegisterFAQSection from './components/RegisterFAQSection';

/**
 * Register页面
 * GBase Support無料トライアル登録页面
 *
 * 页面结构:
 * 1. RegisterHeroSection - 英雄区域
 * 2. RegisterFormSection - 注册表单区域(左侧特典说明+右侧表单)
 * 3. RegisterFeaturesSection - 可体验的功能展示
 * 4. RegisterFAQSection - 常见问题
 */
const RegisterPage: React.FC = () => {
  return (
    <SimpleLayout>
      <div className="font-solution bg-solution-bg">
        {/* Hero区域 */}
        <RegisterHeroSection />

        {/* 注册表单区域 */}
        <RegisterFormSection />

        {/* 可体验功能 */}
        <RegisterFeaturesSection />

        {/* FAQ */}
        <RegisterFAQSection />
      </div>
    </SimpleLayout>
  );
};

export default RegisterPage;
